Vue.asyncComponent('bp-blueprint-top-bar', {
    data() {
        return {
            featureHandler: null,
            topBarWidgets: null,
        }
    },
    props: {
        blueprintId: {
            type: String,
            required: true,
        },
        verticalId: {
            type: String,
            required: true,
        },
        previewMode: {
            type: Boolean,
            required: false,
        },
        showPreviewToggle: {
            type: Boolean,
            default: false
        },
        visibility: {
            type: Object,
        },
        widgetBaseUrl: {
            type: String
        },
        dataProvider: {
            type: Object,
            default: false
        }
    },
    computed: {
        localPreviewMode: {
            get() {
                return this.previewMode;
            },
            set(e) {
                return this.$emit('changePreviewMode', e);
            }
        },
        /**
         * Show the page settings or not
         * @returns {*}
         */
        showPageSettings() {
            return !this.$slots.left && (
                this.showBlueprintCopy ||
                this.showBlueprintShareLink ||
                this.featureHandler.featureSupported('blueprint-header', true) ||
                this.featureHandler.featureSupported('blueprint-metadata', true)
            );
        },
        /**
         * Show blueprint copy
         * @returns {Boolean|*}
         */
        showBlueprintCopy() {
            return this.featureHandler.featureSupported('blueprint-copy', true);
        },
        /**
         * Show blueprint share link
         * @returns {Boolean|*}
         */
        showBlueprintShareLink() {
            return this.featureHandler.featureSupported('blueprint-share-link', true);
        },
        /**
         * Get the blueprint title
         * @returns {*}
         */
        blueprintTitle() {
            return this.dataProvider.getTitle();
        },
        /**
         * Get list label
         * @returns {*}
         */
        listLabel() {
            return this.dataProvider.getListLabel();
        },
        /**
         * Get published toggle label
         *
         * @return {*}
         */
        publishedToggleLabel() {
            return this.dataProvider.getVersionsCount() > 1 ?
                    this.$t('Deze versie publiceren') :
                    this.$t('Gepubliceerd');
        }
    },
    methods: {
        /**
         * Set the scale we want the preview to be renderd
         * @param value
         */
        setPreviewScale(value) {
            this.openPreviewScaleOptions = false;
            this.$emit('changePreviewScale', value);
        },
        /**
         * show the modal where we can copy this page to another vertical
         */
        showCopyToVertical() {
            console.log('@todo: show copy to vertical modal');
        },
        /**
         * trigger the blueprint settings route
         */
        showSettings() {
            this.$router.push({
                name: 'blueprint-settings',
                query: this.$route.query,
                params: { activeTab: 'metadata' }
            });
        },
        /**
         * Get the list url and navigate to the route
         */
        async goToList() {
            const listUrl = await this.dataProvider.getListUrl();

            this.$actionHandler.handleRoute({route: listUrl, target: this.target});
        },
        edit($event) {
            this.$router.push(
                {
                    name: 'blueprint-form' ,
                    params: {
                        blueprintId: this.$route.params.blueprintId,
                        bundle: $event.bundleId,
                        definition: $event.definitionId,
                        objectId: $event.objectId,
                    },
                    query: this.$route.query
                }
            );
        },
        /**
         * Change blueprint verions
         * @param $event
         */
        changeVersion($event) {
            this.$emit('changeVersion', $event);
        },
        /**
         * Refresh the current data
         */
        async refresh() {
            this.$emit('refresh');

            // make sure we refresh the top bar widgets
            this.topBarWidgets = await this.dataProvider.getTopBarWidgets(true);
            this.featureHandler = this.dataProvider.getFeatureHandler();
        }
    },
    beforeDestroy() {
        this.$root.$el.classList.remove('has-ak-top-bar');
    },
    mounted() {
        this.$root.$el.classList.add('has-ak-top-bar');
    },
    async created() {
        this.topBarWidgets = await this.dataProvider.getTopBarWidgets();
        this.featureHandler = this.dataProvider.getFeatureHandler();
    }
}, 'blueprints/bp-blueprint-top-bar.html');
